import { useWriteContract, useWaitForTransactionReceipt, usePublicClient } from 'wagmi';
import { useChainId } from './useChainId';
import { contracts } from '../config/contracts';
import { uploadTextData, cidToBytes32 } from '../utils/dservice-upload';

/**
 * Hook to make a claim on a bounty.
 * Uploads the claim data to dservice and stores the CID hash on-chain.
 */
export function useMakeClaim() {
  const chainId = useChainId();
  const contractAddress = contracts.deployments[chainId]?.SimpleBounty;
  const publicClient = usePublicClient();

  const { writeContract, data: hash, error, isPending, reset } = useWriteContract();
  const { isLoading: isConfirming, isSuccess } = useWaitForTransactionReceipt({
    hash,
  });

  const makeClaim = async (tokenId, claimDataString) => {
    if (!contractAddress) {
      throw new Error('Contract address not configured');
    }
    if (!publicClient) {
      throw new Error('Public client not available');
    }

    // Upload claim data to dservice and get CID
    const cid = await uploadTextData(claimDataString, publicClient);
    // Convert CID to bytes32 for on-chain storage
    const claimData = cidToBytes32(cid);

    await writeContract({
      address: contractAddress,
      abi: contracts.abis.SimpleBounty,
      functionName: 'makeClaim',
      args: [BigInt(tokenId), claimData],
    });
  };

  return {
    makeClaim,
    hash,
    isPending,
    isConfirming,
    isSuccess,
    error,
    reset,
  };
}

